import { PaginatedResponse } from '@frontend/api-utils';

export enum TableViewQueryParams {
    TABLE_ID = 'table_id'
}

/** User preference for how reactive lists refresh when entities are created. */
export type TableViewAutoRefresh = 'manual' | 'delayed' | 'on';

export interface ITableView {
    id: string;
    account_id: string;
    user_id: string;
    table_id: string;
    columns?: string[];
    auto_refresh?: TableViewAutoRefresh | null;
    creation_timestamp: string;
    update_timestamp: string;
    delete_timestamp: string | null;
}

export interface CreateTableView {
    table_id: string;
    columns?: string[];
    auto_refresh?: TableViewAutoRefresh | null;
}

export interface UpdateTableView {
    columns?: string[] | null;
    auto_refresh?: TableViewAutoRefresh | null;
    null_fields?: string[] | null;
}

export type TableViewListResponse = PaginatedResponse<ITableView>;
